module.exports = __webpack_public_path__ + "img/daizy_beach.c6f6cb0f.jpg";